"use client"
import { useEffect, useState } from 'react'
import Link from 'next/link';
import Cookies from 'js-cookie';
import { ErrorMessage, Form, Formik, } from 'formik'
import { EmailSVG, LongArrowLeftSVG } from '@/Component/Common/SVGs/AuthSVG'
import usePost from '@/Utils/Hooks/usePost'
import { ForgotPasswordAPI } from '@/Utils/APIRequest/Endpoints'
import { EmailSchema, YupObject } from '@/Utils/ValidationSchema'
import PrimaryButton from '@/Component/Common/Forms/PrimaryButton';
import { LoaderSVG } from '@/Component/Common/SVGs/CommonSVG';
import FormikInput from '@/Component/Common/Forms/FormikInput';
import FormLabel from '@/Component/Common/Forms/FormLabel';
import AuthTop from '../AuthTop';
import { useTranslation } from '@/Utils/Hooks/useTranslate';
import ValidationMsg from '@/Utils/ValidationSchema/ValidationMsg';
import { useLoading } from '@/Utils/Hooks/useLoading';
import SkeletonLoader from '@/Layout/SkeletonLoader';
import { CustomToast } from '@/Utils/CustomToast';

const ForgotPassword = () => {
    const { translations, locale } = useTranslation();
    const { skeletonLoading, startSkeletonLoading, stopSkeletonLoading } = useLoading();

    const { data, isPending, mutate } = usePost(ForgotPasswordAPI, '/verify-otp', null, null)
    const [forgotEmail, setForgotEmail] = useState('')

    useEffect(() => {
        Cookies.remove('forgot_email')
        Cookies.remove('register_email')
        Cookies.remove('verifyUAT')
        if (data?.status === 200 || data?.status === 201) {
            Cookies.set('forgot_email', forgotEmail)
            CustomToast('success', translations.sentMessage)
        }
    }, [isPending])

    useEffect(() => {
        startSkeletonLoading();
        setTimeout(() => {
            stopSkeletonLoading();
        }, 2000);
    }, [])

    return (
        <div className='mx-auto max-w-xl flex flex-col h-full'>
            <AuthTop skeletonLoading={skeletonLoading} logoutBtn={false} translations={translations} />
            <Link href='/login' className='inline-flex w-fit items-center gap-2 text-xs font-semibold text-neutral-600 hover:text-primary transition-colors mb-6'>
                <LongArrowLeftSVG />
                <span>{translations?.login || 'Back'}</span>
            </Link>
            <span className="kicker mb-3">{translations?.forgotPasswordSubTitle ? '🔐 Reset' : 'Reset access'}</span>
            <h1 className='text-display font-bold lg:text-4xl md:text-3xl sm:text-2xl text-xl mb-3 !leading-[1.05] text-neutral-900'>{skeletonLoading ? <SkeletonLoader height={60} rows={1} /> : translations.forgotPasswordTitle}</h1>
            <p className='text-neutral-600 text-sm'>{skeletonLoading ? <SkeletonLoader width="276" height={24} rows={1} /> : translations.forgotPasswordSubTitle}</p>
            <div className='flex-1'>
                <Formik
                    initialValues={{ email: '', }}
                    validationSchema={YupObject({
                        email: EmailSchema(translations),
                    })}
                    onSubmit={(values: any) => {
                        setForgotEmail(values['email'])
                        values['language'] = locale
                        mutate(values)
                    }}
                >
                    {({ errors, touched }) => (
                        <Form className='sm:mt-10 mt-8'>
                            <div className="mb-7">
                                <FormLabel title={translations.email} skeletonLoading={skeletonLoading}/>
                                <div className="relative">
                                    <EmailSVG customClass='absolute top-1/2 -translate-y-1/2 right-3' />
                                    <FormikInput customClass={'pr-10'} inputProps={{ type: "email", name: "email", placeholder: `${translations.emailPlaceholder}` }} skeletonLoading={skeletonLoading}/>
                                </div>
                                <ErrorMessage name="email" component="div" render={(msg) =>
                                    <ValidationMsg errorMsg={msg} />
                                } />
                            </div>
                            <PrimaryButton customClass='w-full mt-7 flex items-center justify-center !py-3' buttonType='submit' disabled={isPending} skeletonLoading={skeletonLoading} width={'100%'}>
                                {translations.sentOtp}
                                {isPending && <LoaderSVG customClass='ml-2.5' />}
                            </PrimaryButton>
                        </Form>
                    )}
                </Formik>
            </div>
            {/* <AuthBottom title="Don't have an account?" link="/register" linkText="Register Now" /> */}
        </div>
    )
}

export default ForgotPassword
